(() => {
    document.addEventListener('DOMContentLoaded', () => {
        const relatedProducts = document.querySelector('.related__products')
        if(!!relatedProducts === false) return
        let timeout
        const mutationObserver = new MutationObserver(() => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                if(relatedProducts.querySelector('variant-swatch-king')) {
                    relatedProducts.querySelectorAll('.product__grid__info .grid__swatch__container').forEach(item => {
                        item.style.display = 'none'
                    })
                    relatedProducts.querySelector('flickity-carousel').carouselInstance.resize()
                    mutationObserver.disconnect()
                }
            }, 1000)
        })
        mutationObserver.observe(relatedProducts, {
            childList: true,
            subtree: true
        })
    })
})()